<template>
  <section :id="data.id" class="py-[40px] sm:py-[56px]">
    <div class="container grid max-w-none grid-cols-12 justify-items-center">
      <UiLink
        :to="data.banner?.link"
        class="col-span-full mx-auto block w-full max-w-[1824px]"
      >
        <CdnImg
          v-if="banner"
          :src="banner"
          alt=""
          :width="bannerSizes.width"
          :height="bannerSizes.height"
          class="block h-auto w-full rounded-lg"
          loading="lazy"
        />
      </UiLink>
    </div>
  </section>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { CdnImg } from '@webplatform/cdn-image';
import { useBreakpoint } from '~/composables';

interface Props {
  data?: any;
}

const props = withDefaults(defineProps<Props>(), {
  data: () => ({}),
});

const { isBiggerThanBreakpoint: mdAndUp } = useBreakpoint('md');
const banner = computed(() => {
  let image = props.data.banner?.src;

  if (!image) return undefined;

  if (!mdAndUp.value) {
    image =
      props.data.banner.mobile && props.data.banner.mobile.src
        ? props.data.banner.mobile.src
        : props.data.banner.src;
  }
  return image;
});
const bannerSizes = computed(() => {
  if (mdAndUp.value)
    return {
      width: 1824,
      height: 240,
    };
  return {
    width: 654,
    height: 560,
  };
});
</script>

<style lang="scss" scoped>
@media screen and (min-width: 1920px) {
  img {
    height: 240px;
  }
}
</style>
